import React, { useCallback, useEffect, useState } from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import axios from "axios";
import { errorToast, successToast } from "../../../Components/ToastMessage";

const Candidates = () => {
  // Mock Data: List of candidates
  const [candidates, setCandidates] = useState([]);

  // Pagination State
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;

  // Calculate Total Pages
  const totalPages = Math.ceil(candidates.length / rowsPerPage);

  // Get Current Page Data
  const currentRows = candidates.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // Pagination Handlers
  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get("/candidates");
        console.log("====================================");
        console.log(response.data);
        console.log("====================================");
        if (response.data) {
          setCandidates(response.data);
        }
      } catch (error) {
        errorToast(error.message);
      }
    })();
  }, []);

  const handleReject = useCallback(async (id) => {
    try {
      const response = await axios.get(`/candidates/reject/${id}`);

      if (response.data) {
        setCandidates((prev) =>
          prev.map((data) =>
            data._id === response.data._id ? response.data : data
          )
        );

        successToast("Candidate Rejected");
      }
    } catch (error) {
      errorToast(error.message);
    }
  }, []);

  const handleSelect = useCallback(async (id) => {
    try {
      const response = await axios.get(`/candidates/select/${id}`);

      if (response.data) {
        setCandidates((prev) =>
          prev.map((data) =>
            data._id === response.data._id ? response.data : data
          )
        );
        successToast("Candidate Selected");
      }
    } catch (error) {
      errorToast(error.message);
    }
  }, []);

  return (
    <DashboardLayout>
      <div className="bg-gray-100 h-full overflow-y-auto p-6">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Candidates List
        </h1>

        <div className="overflow-x-auto bg-white shadow-md rounded-lg p-6">
          <table className="min-w-full">
            <thead>
              <tr className="bg-gray-200 text-gray-700">
                <th className="py-2 px-4 text-left">ID</th>
                <th className="py-2 px-4 text-left">Name</th>
                <th className="py-2 px-4 text-left">Email</th>
                <th className="py-2 px-4 text-left">Position</th>
                <th className="py-2 px-4 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {currentRows.map((candidate) => (
                <tr
                  key={candidate._id}
                  className="border-b hover:bg-gray-100 transition"
                >
                  <td className="py-2 px-4">{candidate._id}</td>
                  <td className="py-2 px-4">{candidate.name}</td>
                  <td className="py-2 px-4">{candidate.email}</td>
                  <td className="py-2 px-4">{candidate.position?.name}</td>
                  <td className="py-2 px-4">
                    <span
                      className={`px-2 py-1 ${
                        candidate?.status === "Selected"
                          ? "bg-green-200 text-green-800 rounded"
                          : candidate?.status === "Rejected"
                          ? "bg-gray-200 text-black rounded"
                          : "flex gap-3"
                      }`}
                    >
                      {candidate?.status === "Selected" ||
                      candidate?.status === "Rejected" ? (
                        candidate.status
                      ) : (
                        <>
                          <button
                            onClick={() => {
                              handleReject(candidate._id);
                            }}
                            className={`px-4 py-2 rounded bg-gray-500 text-white`}
                          >
                            Reject
                          </button>
                          <button
                            onClick={() => {
                              handleSelect(candidate._id);
                            }}
                            className={`px-4 py-2 rounded bg-blue-500 text-white`}
                          >
                            Accept
                          </button>
                        </>
                      )}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex justify-between items-center mt-4">
            <button
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
              className={`px-4 py-2 rounded ${
                currentPage === 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              Previous
            </button>
            <p className="text-gray-700">
              Page {currentPage} of {totalPages}
            </p>
            <button
              onClick={goToNextPage}
              disabled={currentPage === totalPages}
              className={`px-4 py-2 rounded ${
                currentPage === totalPages
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Candidates;
